import React from 'react'

import ProjectContent from './ProjectContent'

const ProjectPanel = ({ project, current }) =>
  <div
    id={project.slug}
    className={`bg-white min-vh-100 project-panel ${
      current && current.slice(1) == project.slug
      ? 'project-panel-active' : ''
    }`}
  >
    <div className="project-panel-inner">
      <ProjectContent project={project} />
    </div>
  </div>

export default ProjectPanel
